import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { ActionResultModel } from 'src/app/models/common/ActionResultModel';
import { eTypeResult } from 'src/app/models/common/enumModel';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { CompaniaModel } from 'src/app/models/compania/CompaniaModel';
import { FilterCompaniaModel } from 'src/app/models/compania/FilterCompaniaModel';
import { ICompaniaModel } from 'src/app/models/interfaces/compania/ICompaniaModel';
import { IFilterCompaniaModel } from 'src/app/models/interfaces/compania/IFilterCompaniaModel';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';
import { CompaniaService } from 'src/app/services/compania/compania.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';

@Component({
  selector: 'app-configuracion-compania-lista',
  templateUrl: './configuracion-compania-lista.component.html',
  styleUrls: ['./configuracion-compania-lista.component.css']
})
export class ConfiguracionCompaniaListaComponent implements OnInit {

  model!: SearchResultModel<ICompaniaModel[]>;
  filter: IFilterCompaniaModel = new FilterCompaniaModel();
  resultsLength = 0;
  currentPage = 0;

  displayedColumns: string[] = [
    //'id',    
    'nombre',
    //'estado',
    'acciones'
  ];
  @ViewChild('paginator') paginator!: MatPaginator;

  constructor(private serviceCompania: CompaniaService,
    private alertDialogService: AlertDialogService,
    private confirmDialogService: ConfirmDialogService
    ) { 
    this.model = new SearchResultModel<ICompaniaModel[]>(false, new Array<ICompaniaModel>(), 0, 1, 0);
  }

  ngOnInit(): void {
    

    this.serviceCompania.getListFiltered(this.filter).subscribe((data) => {
      this.model = data;
      this.resultsLength = data.total;
    });
  }

  search(): void{
    this.filter.page = 1;
    this.filter.pageSize = 30;
    this.serviceCompania
      .getListFiltered(this.filter)
      .subscribe((data) => {
        this.model = data;
        this.resultsLength = data.total;
        this.currentPage = 0;
        this.paginator.firstPage();
      });
  }

  getPaginatorData(event: any) {
    this.filter.page = event.pageIndex + 1;
    this.filter.pageSize = event.pageSize;
    this.serviceCompania
      .getListFiltered(this.filter)
      .subscribe((data) => {
        this.model = data;
        this.resultsLength = data.total;
      });
  }

  eliminar(company:CompaniaModel){
    this.confirmDialogService.open(`¿Está seguro de eliminar la compañía: ${company.nombre}`); //options
    this.confirmDialogService.confirmed().subscribe((confirmed) => {
      if (confirmed) {
        this.serviceCompania.delete(company.idCompania).subscribe((result: ActionResultModel) => {
          if (result.type != eTypeResult.SUCCESS) {
            this.alertDialogService.open(result.message);
          }
          else {
            this.alertDialogService.open("La compañía ha sido eliminada correctamente.");
          }
          this.search();
        });
      }
    });
  }

}
